<template>
  <div id="AppBody">
    <div class="contentBox">
      <SectionTitleBar :sectionViewName="'Access Control'" />
      <div class="adminSectionBody">
        <table class="adminUserTable">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Admin</th>
              <th>Add Project</th>
              <th>Accessible Projects</th>
            </tr>
          </thead>
          <tbody>
            <AdminUserRow v-for="user in userList" :key="user.uid" :user="user"/>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitleBar from '../components/SectionTitleBar.vue'
import AdminUserRow from '../components/AdminUserRow.vue'

export default {
  name: 'Admin',
  components: {
    SectionTitleBar,
    AdminUserRow
  },
  created() {
    this.$store.dispatch('fetchAllUsers');
    this.$store.dispatch('fireFetchAvailableClients');
  },
  computed: {
    userList () {
      return this.$store.state.users;
    }
  }
}
</script>

<style>
  #AppBody {
    display: grid;
    grid-gap: 10px;
    overflow: hidden;
    padding: 10px 10px 10px 80px;
    flex-grow: 1;
    z-index: 10;
  }
  .adminSectionBody {
    width: 100%;
    height: 100%;
  }
  .adminUserTable {
    width: 100%;
    text-align: left;
    border-collapse: collapse;
  }
  td {
    border: 2px solid #2E303A;
  }
  td, th {
    padding: 15px;
  }
</style>
